<template>
  <div class="gSwiperBox2">
    <swiper :options="swiperOption" :ref="refName">
      <swiper-slide v-for="(item, index) in list" :key="index">
        <img :src="item.url" />
      </swiper-slide>
      <div class="swiper-pagination2" slot="pagination" v-if="list.length > 1"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "gSwiperCommon",
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      refName: "",
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination2",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs[this.refName].swiper;
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   this.swiper.slideTo(3, 1000, false);
    this.refName = `mySwiper-${Math.random()}`;
  },
  methods: {}
};
</script>

<style lang="scss">
.swiper-slide {
  img {
    width: 100%;
  }
}
.gSwiperBox2 {
  position: relative;
  .swiper-container {
    font-size: 0;
  }
  .swiper-pagination2 {
    position: absolute;
    font-size: 0;
    display: flex;
    justify-content: center;
    bottom: 22px;
    z-index: 2;
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      background-color: #ddd;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background-color: #d13119;
      opacity: 1;
    }
  }
}
</style>